export default function netreq(url, type, body = null, headers = {}) {
    return new Promise((resolve, reject) => {
        const request = new XMLHttpRequest();

        let prefix = "";
        if (window.DEBUG_MODE_PREFIX) {
            prefix = window.DEBUG_MODE_PREFIX;
        }

        request.open(type, prefix + url, true);

        let keys = Object.keys(headers);
        keys.forEach((key) => {
            request.setRequestHeader(key, headers[key]);
        });

        request.setRequestHeader("Accept", "application/json");

        request.onload = () => {
            if (request.readyState === 4) {
                if (request.status >= 200 && request.status <= 299) {
                    resolve(request.response);
                    return;
                }

                reject(new Error("response code " + request.status));
            }
        };

        request.onerror = (err) => {
            reject(err);
        }

        request.send(body);
    })
}